/**
 * Standard Query Params
 * Naming for query paramaters sent from the front end to the API
 */
export const StandardQueryParams = {
  INCLUDES: 'includes',
  SORT: 'sort',
  SORT_RAILS: 'sm', // rails backend wants sm
  PAGE: 'page',
  PER_PAGE: 'per_page',
  START_ROW: 'start_row',
  END_ROW: 'end_row',
  SEARCH_QUERY: 'q',
  STARTS_WITH: 'sw',
  SEARCH_TYPE: 'st',
};
